import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, toConsumableArray as _toConsumableArray, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { isValidElement } from 'react';
import { uniqueId } from '../../utils/DomUtils.js';
import { Key } from '../../utils/Keys.js';
import { fragmentMap } from '../../utils/ReactUtils.js';
import { AccordionGroupPresentation } from './AccordionGroupPresentation.js';

var AccordionGroupWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(AccordionGroupWrapper, _React$Component);
  var _super = _createSuper(AccordionGroupWrapper);
  function AccordionGroupWrapper() {
    var _this;
    _classCallCheck(this, AccordionGroupWrapper);
    _this = _super.apply(this, arguments);
    _this.accordionButtonElms = [];
    _this.registerAccordionButtonElm = function (index) {
      return function (elm) {
        return (
          // Registers a new elements, but also deletes elements that are no longer there
          _this.accordionButtonElms = elm ? [].concat(_toConsumableArray(_this.accordionButtonElms.slice(0, index)), [elm], _toConsumableArray(_this.accordionButtonElms.slice(index))) : _this.accordionButtonElms.slice(index, 1)
        );
      };
    };
    _this.keyHandler = function (e) {
      var index = NaN;
      _this.accordionButtonElms.forEach(function (item, i) {
        if (item === document.activeElement) {
          index = i;
        }
      });
      if (!Number.isNaN(index)) {
        var newFocusedElem = document.activeElement;
        switch (e.key) {
          case Key.ArrowDown:
            e.preventDefault();
            newFocusedElem = index < _this.accordionButtonElms.length - 1 ? _this.accordionButtonElms[index + 1] : document.activeElement;
            break;
          case Key.ArrowUp:
            e.preventDefault();
            newFocusedElem = index > 0 ? _this.accordionButtonElms[index - 1] : document.activeElement;
            break;
          case Key.Home:
            e.preventDefault();
            newFocusedElem = _this.accordionButtonElms[0];
            break;
          case Key.End:
            e.preventDefault();
            newFocusedElem = _this.accordionButtonElms[_this.accordionButtonElms.length - 1];
            break;
        }
        newFocusedElem.focus();
      }
    };
    _this.setOpenIndex = function (index) {
      return function (_open, _id, ev) {
        // elaborate checking because of typescript props interface definintion
        if (!_this.props.multiple) {
          _this.props.onChange(_this.props.openIndex !== index ? index : -1, _this.props.id, ev);
        }
      };
    };
    return _this;
  }
  _createClass(AccordionGroupWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement(AccordionGroupPresentation, Object.assign({}, this.props), fragmentMap(this.props.children, function (child, i) {
        if (! /*#__PURE__*/isValidElement(child)) {
          return;
        }
        var additionalProps = {
          onKeyDown: _this2.keyHandler,
          actionRef: _this2.registerAccordionButtonElm(i)
        };
        if (!_this2.props.multiple) {
          additionalProps.isOpen = _this2.props.openIndex === i;
          additionalProps.onChange = _this2.setOpenIndex(i);
          additionalProps.id = child.props.id || uniqueId("accordion-");
        }
        return /*#__PURE__*/React.cloneElement(child, additionalProps);
      }));
    }
  }]);
  return AccordionGroupWrapper;
}(React.Component);

export { AccordionGroupWrapper };
